import React, { forwardRef } from "react";

import MenuItem from "./MenuItem";

const Dropdown = forwardRef(({ show, submenu }, ref) => (
  <ul ref={ref} className={`dropdown ${show ? "show" : ""}`}>
    {submenu && submenu.map((submenu, index) => (
      <MenuItem key={index} item={submenu} />
    ))}
  </ul>
));

export default Dropdown;
